import gql from 'graphql-tag'

const coupons = gql`
  query coupons(
    $limit: Int!
    $offset: Int
    $where: CouponsFilterInput
    $orderBy: [CouponsOrderBy]
  ) {
    coupons(limit: $limit, offset: $offset, where: $where, orderBy: $orderBy) {
      totalCount
      nodes {
        id
        codice
        stato
        importo
        clienteId
        cliente {
          id
          nome
        }
        dataCreazione
        dataLimiteAssegnazione
        dataLimiteAttivazione
        dataLimiteUtilizzo
        tipologia
      }
    }
  }
`

export default coupons



// WEBPACK FOOTER //
// ./src/graphql/queries/coupons.js